<template>
  <div class="auth-page">
    <div class="auth-card">
      <h2 class="auth-title">上网认证</h2>

      <!-- <div class="form-group">
        <label class="form-label">MAC</label>
        <input
          v-model="formData.mac"
          class="form-input"
          placeholder="可自动获取，也可手动输入 MAC"
        />
      </div> -->

      <div class="form-group">
        <label class="form-label">卡号</label>
        <input v-model="formData.iccid" class="form-input" placeholder="可自动获取，也可手动输入卡号" />
      </div>


      <button class="auth-btn" @click="handleAuth">认证</button>
    </div>
  </div>
</template>

<script>
import { wxRequest } from "@/api/user";
import { Toast } from "vant";
import { Dialog } from 'vant';

export default {
  data() {
    return {
      formData: {
        mac: "",
        iccid: "",
        imsi: "",
      },
    };
  },
  created() {
    //localStorage.getItem("iccid") || ""
    if (this.$route.query.iccid) {
      this.formData.iccid = this.$route.query.iccid;
    }
    if (this.formData.iccid && this.formData.iccid.length > 2) {
      this.handleAuth();
    }

  },
  methods: {

    handleAuth() {
      if (!this.formData.iccid) {
        Toast("请填写认证信息");
        return;
      }
      wxRequest("/sim/to/shebei/auth", this.formData, "post")
        .then((res) => {
          if (res.data.code == "200") {
            window.location.href = res.data.data;
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            });
          }
        })
        .catch(() => {
          Toast(res.data.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.auth-page {
  min-height: 100vh;
  background-color: #eef1f6;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.auth-card {
  background: #fff;
  border-radius: 12px;
  padding: 40px 30px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.auth-title {
  text-align: center;
  color: #1a56db;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 30px 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.2s;

  &::placeholder {
    color: #c0c4cc;
  }

  &:focus {
    border-color: #1a56db;
  }
}

.auth-btn {
  width: 100%;
  height: 44px;
  background: #3662ec;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.2s;

  &:active {
    background: #2850d0;
  }
}
</style>
